// extracted by mini-css-extract-plugin
module.exports = {"box":"form-message_box__2GAce","boxRed":"form-message_boxRed__3u0XX"};